var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"rules",on:{"click":_vm.showModal}},[_vm._v("活动规则")]),_c('rule-modal',{ref:"ruleModal",attrs:{"data":_vm.rule}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }